<template>
  <v-chip
    small
    :color="config.color"
    :text-color="config.textColor"
    class="font-weight-medium"
  >
    {{ config.label }}
  </v-chip>
</template>

<script>
const STATI = {
  0: { label: "Bozza",      color: "grey lighten-2",  textColor: "grey darken-3" },
  1: { label: "Confermata", color: "blue lighten-4",  textColor: "blue darken-3" },
  2: { label: "Convertita", color: "green lighten-4", textColor: "green darken-3" },
  3: { label: "Annullata",  color: "red lighten-4",   textColor: "red darken-3" },
};

export default {
  name: "StatoBadge",
  props: {
    stato: {
      type: Number,
      required: true,
    },
  },
  computed: {
    config() {
      return STATI[this.stato] ?? { label: "—", color: "grey", textColor: "white" };
    },
  },
};
</script>
